export const TransportOptions = {
  none: 0,

  interCity: 1,
  interCityExpress: 2,
  regionalTrain: 4,
  otherTrain: 8,
  sTrain: 16,

  ordinaryBus: 32,
  expressBus: 64,
  nightBus: 128,
  otherBus: 256,

  metro: 1024,

  allTrain: 1 | 2 | 4 | 8 | 16,
  allBus: 32 | 64 | 128 | 256,
}
